import {Component, Input, OnInit} from '@angular/core';
import {HttpService} from '../../_service/http.service';
import {ActivatedRoute} from '@angular/router';
import {DateService} from '../../_service/date.service';
import {FlashMessagesService} from 'angular2-flash-messages';
import {MeterValueService} from './meter-value.service';
import {MetersValuesModel} from './meters-values-model';
import {isNullOrUndefined} from 'util';
import {DomSanitizer} from '@angular/platform-browser';
import {ViewSettingService} from '../../main-page/view-setting-service/view-setting.service';
import {MeteringUnitConversionService} from '../../_service/metering-unit-conversion.service';

declare var $: any;

@Component({
  selector: 'app-send-values-widget',
  templateUrl: './send-values-widget.component.html',
  styleUrls: ['./send-values-widget.component.css', '../../../css/main.css', '../../../css/common.css']
})
export class SendValuesWidgetComponent implements OnInit {

  private orgName: String;
  metersValues: any;
  postMeterValues: any;
  tariffNames: { name1: string, name2: string, name3: string }[];
  valueLimits: any = null;
  prevPrevBillingPeriod: any;
  prevBillingPeriod: any;
  currBillingPeriod: any;
  nextBillingPeriod: any;
  userBillingPeriod: any;
  isNowCalculatingPeriod: boolean;
  dayPeriodEndForCurrBillingPeriod: any;
  dayPeriodEndForCurrMonth: any;
  isTodayLate: boolean;
  isSuccessSentValues: boolean;
  cssName: any;
  /* Количество ячеек при вводе показаний !по умолчанию!
   * Не дай себя обмануть названием, кроме смены этого числа нужно еще добавлять инпуты
   */
  CELLS_NUMBER = 9;
  // Знаки после запятой
  PRECISION = 0.001;
  VALUES_PRECISION = 3;

  //
  type = null;

  message = 'Загрузка';
  metersValuesModel: MetersValuesModel;

  @Input() public accountNumber: any;

  constructor(public viewSettingService: ViewSettingService,
                private httpService: HttpService, private route: ActivatedRoute,
              private dateService: DateService, public sanitizer: DomSanitizer,
              private flashMessagesService: FlashMessagesService,
              private meterValueService: MeterValueService,
              private meteringUnitConversionService: MeteringUnitConversionService) {
    this.tariffNames = [];
    this.postMeterValues = [];
  }

  ngOnInit() {
    // console.debug("Realty: ", this.currentRealty);
    console.debug("accountNumber: ", this.accountNumber);
    this.initSvgAndCss();
    this.getMetersValuesFromServer();
    this.type = this.route.snapshot.queryParams['type'];
  }

  initSvgAndCss() {

    let ukName = 'uk-akadem';
    this.viewSettingService.initStylesAndSvg().then((data1) => {
      ukName = data1;
      this.cssName = this.sanitizer.bypassSecurityTrustResourceUrl('css/theme-' + ukName + '.css');
      // if ($('#ukStyle').length === 0 && ukName !== '') {
      //   $('body').append('<link id="ukStyle" rel="stylesheet" type="text/css" href="css/theme-' + ukName + '.css">');
      // }
      const file = 'img/svg-pack-' + ukName + '.svg', // путь к файлу спрайта на сервере
        revision = 1;            // версия спрайта
      if (!document.createElementNS || !document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect) {
        return true;
      }
      let request, data;
      let isLocalStorage = false;
      try {
        isLocalStorage = !isNullOrUndefined(window.sessionStorage);
      } finally {}

      const insertIT = function () {
          const elem = document.createElement('div');
          elem.id = 'svg-data';
          elem.innerHTML = data;
          document.body.insertAdjacentElement('afterbegin', elem);
          if (!isNullOrUndefined(ukName) && ukName !== '') {
            document.body.insertAdjacentHTML('afterbegin',
              '<link id="ukStyle" rel="stylesheet" type="text/css" href="css/theme-' + ukName + '.css">');
          }
        },
        insert = function () {
          if (document.body) {
            insertIT();
          } else {
            document.addEventListener('DOMContentLoaded', insertIT);
          }
        };
      // if (isLocalStorage && sessionStorage.getItem('inlineSVGrev') === revision.toString()) {
      //   data = sessionStorage.getItem('inlineSVGdata');
      //   if (data) {
      //     insert();
      //     return true;
      //   }
      // }
      try {
        request = new XMLHttpRequest();
        request.open('GET', file, true);
        request.onload = function () {
          if (request.status >= 200 && request.status < 400) {
            data = request.responseText;
            insert();
            // if (isLocalStorage) {
            //   sessionStorage.setItem('inlineSVGdata', data);
            //   sessionStorage.setItem('inlineSVGrev', revision.toString());
            // }
          }
        };
        request.send();
      } catch (e) {
      }
    });
  }



  private async getMetersValuesFromServer() {

    const alias = this.route.snapshot.pathFromRoot[1].params.alias;

    await this.meterValueService.getMetersValuesByAccount(this.accountNumber, alias)
      .then((data) => {

        this.metersValuesModel = data;
        this.isTodayLate = data.isTodayLate;
        this.metersValues = data.metersValues;
        this.metersValues.sort((a, b) => ((a.viewOrder) - (b.viewOrder)));
        this.currBillingPeriod = data.currBillingPeriod;
        this.prevBillingPeriod = data.prevBillingPeriod;
        this.nextBillingPeriod = data.nextBillingPeriod;
        this.userBillingPeriod = data.userBillingPeriod;
        this.prevPrevBillingPeriod = data.prevPrevBillingPeriod;
        this.isNowCalculatingPeriod = data.isNowCalculatingPeriod;
        this.dayPeriodEndForCurrMonth = data.dayPeriodEndForCurrMonth;
        this.dayPeriodEndForCurrBillingPeriod = data.dayPeriodEndForCurrBillingPeriod;
        this.valueLimits = data.meterValueLimitSetting;
        this.orgName = data.orgName;


        this.initMeterValues(this.metersValuesModel.metersValues);
        if (this.metersValuesModel.metersValues != null ||
          this.metersValuesModel.metersValues.length == 0) {
          this.message = 'Нет данных';
        }

        this.updateTariffNames(this.metersValues);
        this.postMeterValues = this.cloneMetersValuesObject(this.metersValues);
        this.addDeltaToMeterValues(this.postMeterValues);

        this.updateMessagesNames(this.metersValues);

        console.log("Clonned values: ", this.postMeterValues);

      }, (error) => {
        this.message = 'Нет данных';
      });
  }

  private async postValues(values, modal) {

    const alias = this.route.snapshot.pathFromRoot[1].params.alias;

    await this.meterValueService.postMetersValuesForWidget(
      this.metersValuesModel.realtyExternalId,
      this.getAttemptsNumber(values),
      this.accountNumber,
      this.transformToPostValues(values),
      alias)
      .then((data) => {

        // this.flashMessagesService.show('Показания успешно отправлены',
        //   {cssClass: 'popup-message flashfade alert-success', timeout: 5000});
        this.getMetersValuesFromServer();
        if(this.type === 'monoblock') {

          const redirectUrl = '/monoblock/main?orgId=' + alias + '&accountId=' + this.accountNumber + '&orgName=' + this.orgName + '&type=sendValue&status=success';

          if (window.top !== undefined) {
            window.top.location.href = redirectUrl;
          } else {
            window.location.href = redirectUrl;
          }
        } else {
          modal.show();
        }
        console.log('Post meeters answer: ', data);
      }, (error) => {
        console.warn(error);
        this.isSuccessSentValues = false;
        this.flashMessagesService.show(error._body,
          {cssClass: 'popup-message flashfade alert-danger', timeout: 5000});
        console.warn('Post meeters  ERROR:', error);
      });
  }

  sendValues(modal) {
    console.log('MODAL IS', modal);

    let convertedValues = this.convertValues();
    console.warn('SEND VALUES: ', convertedValues);

    if (this.checkHalfFilledMeters(convertedValues)) return;

    const notEmptyValues = convertedValues.filter(meter => !this.isEmpty(meter));

    console.warn('SEND VALUES: ', notEmptyValues);

    if (!this.checkValues(notEmptyValues)) {
      return;
    }

    console.log("POSTEED VALUES: ", notEmptyValues);
    this.postValues(notEmptyValues, modal);
  }

  allowEdit(meter) {

    console.log("Allowing meter to edit", meter);

    if (meter == null) {
      return;
    }
    // TODO?: Вы действительно хотите редактировать?"
    meter.editing = !meter.editing;
  }

  isNeedEditOption(meter) {

    if (meter == null) {
      return false;
    }

    return meter.value1 != null || (meter.late && meter.value1 != null) ||
      meter.sendValuesAccess == 'ALLOW_WITH_NOTIFICATION' || meter.dispatchingStatus == "CONNECTED";
  }

  isNeedToDisableValueEntering(meter, meterValue): boolean {
    return (meter.sendValuesAccess == 'RESTRICT' || meterValue != null ||
      meter.dispatchingStatus == 'CONNECTED' ||
      meter.sendValuesAccess == 'ALLOW_WITH_NOTIFICATION') && !meter.editing;
  }

  private initMeterValues(meterValues: any) {
    console.log("Before adding, uk: ", meterValues);
    // meterValues.uk =  meterValues.uk.map(m => this.setBillingTypeOrSource(m));
    for (let mVal of meterValues) {
      mVal.uk = this.setBillingTypeOrSource(mVal.uk);
      mVal.prevUk = this.setBillingTypeOrSource(mVal.prevUk);
      mVal.editing = false;
    }
    console.log("After: ", meterValues);
  }

  // TODO: Rename (D)
  public getMeterValueMessage(meterValueObj: any, meterValue) {

    if (meterValueObj != null && meterValueObj.sendValuesAccess == 'RESTRICT') {
      return "—";
    }

    if (meterValueObj.dispatchingStatus == "CONNECTED" && meterValue == null) {
      return "Показания будут получены через систему диспетчеризации." +
        " Передать вручную";
    }

    const nextMonthString = this.dateService.getMonthNameDateWhenCase(this.nextBillingPeriod);

    if (meterValue != null) {

      if (meterValueObj.isLate) {
        const userSendDate = this.dateService.getTwoDigitDate(meterValueObj.userSendDate, true);

        return meterValue.toFixed(3) + ", " + userSendDate + "; будут учтены в " + nextMonthString;
      }
      return meterValue.toFixed(3);
    }

    if (this.isTodayLate) {
      return "Не переданы, будут учтены в " + nextMonthString;
    }

    const dayPeriodEndStr = this.dateService.getTwoDigitDate(
      this.dateService.clearTimeZone(this.dayPeriodEndForCurrBillingPeriod), false);
    return 'Не переданы, ' +
      'прием показаний до ' + dayPeriodEndStr + ' вкл.';
  }

  private getMeterValueMessageObject(meterValueObj: any, meterValue) {

    let mObject = {} as any;
    mObject.isLateWithNewValue = false;

    if (meterValueObj != null && meterValueObj.sendValuesAccess == 'RESTRICT') {
      mObject.message = "—";
      return mObject;
    }

    if (meterValueObj.dispatchingStatus == "CONNECTED" && meterValue == null) {
      mObject.message = "Показания будут получены через систему диспетчеризации." +
        " Передать вручную";
      return mObject;
    }

    const nextMonthString = this.dateService.getMonthNameDateWhenCase(this.nextBillingPeriod);

    if (meterValue != null) {

      if (meterValueObj.isLate) {
        const userSendDate = this.dateService.getTwoDigitDate(meterValueObj.userSendDate, true);

        mObject.isLateWithNewValue = true;
        mObject.messageOldDate = userSendDate;
        mObject.messageOldValue = meterValue.toFixed(3);

        mObject.message = "будут учтены в " + nextMonthString;
        return mObject;
      }

      mObject.message = meterValue.toFixed(3);
      return mObject;
    }

    if (this.isTodayLate) {
      mObject.message = "Не переданы, будут учтены в " + nextMonthString;
      return mObject;
    }

    const dayPeriodEndStr = this.dateService.getTwoDigitDate(
      this.dateService.clearTimeZone(this.dayPeriodEndForCurrBillingPeriod), false);
    mObject.message = 'Не переданы, прием показаний до ' + dayPeriodEndStr + ' вкл.';
    return mObject;

  }

  private addDeltaToMeterValues(postMeterValues) {

    for (let i = 0; i < postMeterValues.length; i++) {

      if (postMeterValues[i].value1 == null ||
        postMeterValues[i].activeValuesNumber < 1) continue;

      let bufferValue1 = postMeterValues[i].value1;
      postMeterValues[i].value1 = {
        error: false, impossible: false,
        readings: bufferValue1, attempts: 0
      };

      if (postMeterValues[i].value2 == null ||
        postMeterValues[i].activeValuesNumber < 2) continue;

      let bufferValue2 = postMeterValues[i].value2;
      postMeterValues[i].value2 = {
        error: false, impossible: false,
        readings: bufferValue2, attempts: 0
      };

      if (postMeterValues[i].value3 == null ||
        postMeterValues[i].activeValuesNumber < 3) continue;

      let bufferValue3 = postMeterValues[i].value3;
      postMeterValues[i].value3 = {
        error: false, impossible: false,
        readings: bufferValue3, attempts: 0
      };
    }
    // console.log("Added delta: ", postMeterValues);
  }

  getDeltaWithDesc(ukValue, userValue, valMeteringUnit) {

    const delta = this.getDelta(ukValue, userValue);

    if (delta == null) {
      return null;
    }

    if (delta < 0) {
      return "Ожидаемый перерасчет " + delta.toFixed(this.VALUES_PRECISION)
        + (valMeteringUnit == null ? '' : ' ' + this.meteringUnitConversionService
            .convert(valMeteringUnit));
    }

    return "Ожидаемое потребление " + delta.toFixed(this.VALUES_PRECISION)
      + (valMeteringUnit == null ? '' : ' ' + this.meteringUnitConversionService
          .convert(valMeteringUnit));

  }

  getDelta(ukValue: number, userValue: Array<number>): number {

    /* Если предыдущих показаний из УК нету либо сейчас расчетный период (во время него мы
     * отображаем показания не предыдущие и пред предыдущие, а пред предыдущие
     * и пред пред предыдущие, соответственно дельту считать относительно их не корректно)
     *  то не выводим дельту
     */
    if (ukValue == null || this.isNowCalculatingPeriod) {
      return null;
    }

    let userValueNumber = this.fromArrToNumber(userValue);

    if (userValueNumber == 0) {
      return null;
    }

    // console.log("ukValue: ", ukValue);
    const delta = userValueNumber - ukValue;
    console.log('Getting delta ', delta);

    return delta;
  }

  setBillingTypeOrSource(meterValue: any): any {

    // console.log("Set billingType or source", meterValue);

    let sourceOrBillingType = {value: meterValue.source, isDanger: false};

    if (meterValue.source == "Неизвестно " || meterValue.source == "NONE" ||
      meterValue.source == "" || meterValue.source == null) {

      sourceOrBillingType.value = '';
    }

    const billingType = this.getBillingType(meterValue);
    if (billingType == '') {
      meterValue.sourceOrBillingType = sourceOrBillingType;
      return meterValue;
    }

    if (billingType == "Расчет по среднему" || billingType == "Расчет по нормативу") {
      sourceOrBillingType.isDanger = true;
      sourceOrBillingType.value = meterValue.billingType;
    }

    meterValue.sourceOrBillingType = sourceOrBillingType;
    return meterValue;
  }

  getBillingType(meterValue) {

    if (meterValue.billingType == null || meterValue.billingType == "Неизвестно" ||
      meterValue.billingType == '' || meterValue.billingType == "Расчет по показаниям") {
      return '';
    }

    return meterValue.billingType;
  }

  private checkHalfFilledMeters(values: any) {
    // console.log("CHECK half filled meters: ", values);
    for (let v of values) {
      if (v.activeValuesNumber == 2) {
        if ((v.value1.readings == 0 || v.value2.readings == 0) && v.value1.readings != v.value2.readings) {
          this.flashMessagesService.show('Заполните показания по обоим тарифам счетчика'
            + (v.name != null ? " '" + v.name + "'" : ''),
            {cssClass: 'popup-message flashfade_10 alert-danger', timeout: 10000});
          return true;
        }
      }
    }

    return false;
  }

  private transformToPostValues(values) {

    let postList = [];
    for (let v of values) {
      postList.push({
        meterId: v.meterId, activeValuesNumber: v.activeValuesNumber,
        value1: v.value1 != null ? v.value1.readings : null,
        value2: v.value2 != null ? v.value2.readings : null,
        value3: v.value3 != null ? v.value3.readings : null
      });
    }
    return postList;
  }

  private updateMessagesNames(metersValues) {
    for (let i = 0; i < metersValues.length; i++) {
      const metersValue = metersValues[i];
      metersValue.messageObjects = {} as any;
      metersValue.messageObjects = {} as any;
      metersValue.messageObjects = {} as any;
      metersValue.messageObjects["value1"] = this.getMeterValueMessageObject(metersValue, metersValue.value1);
      metersValue.messageObjects["value2"] = this.getMeterValueMessageObject(metersValue, metersValue.value2);
      metersValue.messageObjects["value3"] = this.getMeterValueMessageObject(metersValue, metersValue.value3);
    }
  }

  private updateTariffNames(metersValues) {
    for (let i = 0; i < metersValues.length; i++) {
      if (metersValues[i].resourceType == 'ELECTRICITY') {
        if (metersValues[i].activeValuesNumber == 1) {
          this.tariffNames.push({name1: 'T1: ', name2: '', name3: ''});
        } else {
          this.tariffNames.push({name1: 'День: ', name2: 'Ночь: ', name3: 'T3: '});
        }
      } else {
        if (metersValues[i].activeValuesNumber == 1) {
          this.tariffNames.push({name1: '', name2: '', name3: ''});
        } else {
          this.tariffNames.push({name1: 'T1: ', name2: 'T2: ', name3: 'T3: '});
        }
      }
    }
  }

  private cloneMetersValuesObject(metersValues) {

    const clonedMetersValues = JSON.parse(JSON.stringify(metersValues));

    for (let i = 0; i < clonedMetersValues.length; i++) {
      /* Т.к. объект скопирован в нем могут лежать предыдущие показания
       * -> надо их обнулить в новом объекте
       */

      let arrValues1 = this.convertValueToArr(clonedMetersValues[i],
        clonedMetersValues[i].value1, 1);

      if (clonedMetersValues[i].activeValuesNumber >= 1) {
        clonedMetersValues[i].value1 = arrValues1;
      }

      let arrValues2 = this.convertValueToArr(clonedMetersValues[i],
        clonedMetersValues[i].value2, 2);

      if (clonedMetersValues[i].activeValuesNumber >= 2) {
        clonedMetersValues[i].value2 = arrValues2;
      }

      let arrValues3 = this.convertValueToArr(clonedMetersValues[i],
        clonedMetersValues[i].value3, 3);

      if (clonedMetersValues[i].activeValuesNumber >= 3) {
        clonedMetersValues[i].value3 = arrValues3;
      }
    }

    console.log('Clonned meter values object is: ', clonedMetersValues);
    return clonedMetersValues;
  }

  private convertValueToArr(meter, value, valueNumber) {

    if (value != null || meter.activeValuesNumber >= valueNumber) {

      if (meter.inputLength.integerPartLen != null && meter.inputLength.fractionalPartLen != null) {
        return Array(meter.inputLength.integerPartLen + meter.inputLength.fractionalPartLen)
          .fill('');
      }

      return Array(this.CELLS_NUMBER).fill('');
    }
    return null;
  }

  private convertValues() {

    console.debug('Converting values');
    const copyForServer = JSON.parse(JSON.stringify(this.postMeterValues));

    for (let i = 0; i < this.postMeterValues.length; i++) {

      if (this.postMeterValues[i].value1 != null && this.postMeterValues[i].activeValuesNumber >= 1) {
        copyForServer[i].value1.readings = this.fromArrToNumber(this.postMeterValues[i].value1.readings);
      }

      if (this.postMeterValues[i].value2 != null && this.postMeterValues[i].activeValuesNumber >= 2) {
        copyForServer[i].value2.readings = this.fromArrToNumber(this.postMeterValues[i].value2.readings);
      }

      if (this.postMeterValues[i].value3 != null && this.postMeterValues[i].activeValuesNumber >= 3) {
        copyForServer[i].value3.readings = this.fromArrToNumber(this.postMeterValues[i].value3.readings);
      }
    }

    return copyForServer;
  }

  private fromArrToNumber(meterValue) {
    return (+meterValue.map(char => char || '0').reduce((str, char) => str + char)) * this.PRECISION;
  }

  private checkValues(values): boolean {

    if (values.length == 0) {
      this.flashMessagesService.show('Вы должны заполнить показания хотя бы для одного счетчика',
        {cssClass: 'popup-message flashfade alert-danger', timeout: 5000});
      return false;
    }

    if (!this.checkFormat(values)) {
      // console.log('Values are invalid');

      this.flashMessagesService.show('Вы ввели не корректные показания!',
        {cssClass: 'popup-message flashfade alert-danger', timeout: 5000});
      return false;
    }

    if (this.valueLimits !== null) {
      this.checkDelta(this.postMeterValues);

      if (this.getAmountOfImpossibles(this.postMeterValues) > 0) {
        this.showImpossibles(this.postMeterValues);
        if (this.getAmountOfNotConfirmedErrors(this.postMeterValues) > 0) {
          this.showErrors(this.postMeterValues);
          this.incrementAttemptsNumber(this.postMeterValues);
        }
        // console.log('Impossible values:', this.postMeterValues);
        return false;
      }

      // Если есть еще ошибки, которые попытались отправить впервые
      if (this.getAmountOfNotConfirmedErrors(this.postMeterValues) > 0) {
        // console.log("In errrors");
        this.showErrors(this.postMeterValues);
        this.incrementAttemptsNumber(this.postMeterValues);
        return false;
      }

      this.incrementAttemptsNumber(this.postMeterValues);

    }
    console.log('Value limits = null');

    return true;
  }

  private checkDelta(values: Array<any>) {
    this.checkImpossible(values);
    // TODO Если нет лимитов
    this.checkError(values);
  }

  closeModalAndHighlightValues(modal) {
    modal.hide();
    this.isSuccessSentValues = true;
  }

  onKeyUpFunc(event, meterIndex, readingsDigitIndex, valueNumber) {

    // console.log('Event is ', event);
    // console.log('Event curr target is ', event.currentTarget);
    // console.log('Event curr target value ', event.currentTarget.value);
    // console.log('Event values digit ', this.getPostValuesReadingDigit(meterIndex, valueNumber, readingsDigitIndex));

    event.currentTarget.select();

    if (event.shiftKey) {
      return;
    }

    if (event.key === 'ArrowLeft' || event.key === 'Left') {
      $(event.currentTarget.previousElementSibling).focus();
      return;
    } else if (event.key === 'Backspace' || event.keyCode === 8) {
      if (this.getPostValuesReadingDigit(meterIndex, valueNumber, readingsDigitIndex) == '') {
        if (event.currentTarget.previousElementSibling != null) {
          event.currentTarget.previousElementSibling.value = '';
          $(event.currentTarget.previousElementSibling).focus();
        }
        this.setPostValuesReadingDigit(meterIndex, valueNumber, readingsDigitIndex - 1, '');
        return;
      }
      event.currentTarget.value = '';
      this.setPostValuesReadingDigit(meterIndex, valueNumber, readingsDigitIndex, '');
      if (event.currentTarget.previousElementSibling != null &&
        event.currentTarget.previousElementSibling.value != '') {

        $(event.currentTarget.previousElementSibling).focus();
      }
      return;
    } else if (event.key === 'ArrowRight' || event.key === 'Right') {
      $(event.currentTarget.nextElementSibling).focus();
      return;
    } else if (event.keyCode === 229) {
      // Сюда приходят неопознаные кнопки
      // dataSteps.push("keyCode === 229! " + "" +
      //   ". which: " + event.which + "" +
      //   ". key " + event.key +
      //   ". keyCode " + event.keyCode +
      //   ". code " + event.code +
      //   ". charCode " + event.charCode);
    }

    /* Всякие символы, не являющиеся цифрами оставлять в полях не надо,
     * поэтому заменяем их на то что лежало в ячейке до этого
     */
    if (isNaN(parseInt(event.currentTarget.value)) && event.key != 'Backspace' &&
      event.key != 'Delete') {

      switch (valueNumber) {
        case 1:
          event.currentTarget.value = this.postMeterValues[meterIndex]
            .value1.readings[readingsDigitIndex];
          break;
        case 2:
          event.currentTarget.value = this.postMeterValues[meterIndex]
            .value2.readings[readingsDigitIndex];
          break;
        case 3:
          event.currentTarget.value = this.postMeterValues[meterIndex]
            .value3.readings[readingsDigitIndex];
          break;
      }
      event.currentTarget.select();
      return;
    }

    /* Если ввели цифру поверх заполненой ячейки - можем заменить значение'
     * если вводить будут очень быстро сюда может попасть число а не цифра,
     * в этом случае берем только последнюю введенную цифру
     */
    if (!isNaN(parseInt(event.currentTarget.value))) {
      event.currentTarget.value = event.currentTarget.value % 10;
    }

    this.setPostValuesReadingDigit(meterIndex, valueNumber, readingsDigitIndex, event.currentTarget.value);

    // if (event.currentTarget.value.length == 1 && !isNaN(parseInt((event.key)))) {
    if (event.currentTarget.value.length == 1) {
      $(event.currentTarget.nextElementSibling).focus();
    }
  }

  private getPostValuesReadingDigit(meterIndex, valueNumber, digitIndex) {

    if (digitIndex < 0 || digitIndex > this.postMeterValues[meterIndex].value1.readings.length) {
      return '';
    }

    switch (valueNumber) {
      case 1:
        return this.postMeterValues[meterIndex].value1.readings[digitIndex];
      case 2:
        return this.postMeterValues[meterIndex].value2.readings[digitIndex];
      case 3:
        return this.postMeterValues[meterIndex].value3.readings[digitIndex];
    }
  }

  private setPostValuesReadingDigit(meterIndex, valueNumber, digitIndex, value) {

    if (digitIndex < 0 || digitIndex > this.postMeterValues[meterIndex].value1.readings.length) {
      return '';
    }

    switch (valueNumber) {
      case 1:
        return this.postMeterValues[meterIndex].value1.readings[digitIndex] = value;
      case 2:
        return this.postMeterValues[meterIndex].value2.readings[digitIndex] = value;
      case 3:
        return this.postMeterValues[meterIndex].value3.readings[digitIndex] = value;
    }
  }

  //<editor-fold desc="Обработка ошибок\предупреждений при отправлении показаний">
  // TODO: Подумоть как решать проблему с тем что везде value1,2,3 отдельно проверяется
  // а в случае ошибок всяких вообще отдно и то же пишется
  private checkError(values: Array<any>) {

    for (let v of values) {

      if (v.resourceType == "ELECTRICITY") {

        if (v.value1 == null || v.value2 == null) return;

        console.debug('Checking error value:', v);
        console.debug('Checking error settings', this.valueLimits.settings);
        console.debug('Checking error particular settings _DAY', this.valueLimits.settings[v.resourceType + "_DAY"]);
        console.debug('Checking error Delta', this.getDelta(v.uk.value1, v.value1.readings));
        console.debug('Checking error errorLimitReacher', this.isErrorLimitReached(this.getDelta(v.uk.value1, v.value1.readings),
          this.valueLimits.settings[v.resourceType + "_DAY"]));

        v.value1.error = this.isErrorLimitReached(this.getDelta(v.uk.value1, v.value1.readings),
          this.valueLimits.settings[v.resourceType + "_DAY"]);

        v.value2.error = this.isErrorLimitReached(this.getDelta(v.uk.value2, v.value2.readings),
          this.valueLimits.settings[v.resourceType + "_NIGHT"]);

      } else {

        if (v.value1 == null) continue;
        v.value1.error = this.isErrorLimitReached(this.getDelta(v.uk.value1, v.value1.readings),
          this.valueLimits.settings[v.resourceType]);

        if (v.value2 == null) continue;
        v.value2.error = this.isErrorLimitReached(this.getDelta(v.uk.value2, v.value2.readings),
          this.valueLimits.settings[v.resourceType]);

        if (v.value3 == null) continue;
        v.value3.error = this.isErrorLimitReached(this.getDelta(v.uk.value3, v.value3.readings),
          this.valueLimits.settings[v.resourceType]);
      }
    }
  }

  private checkImpossible(values: Array<any>) {

    for (let v of values) {

      if (v.resourceType == "ELECTRICITY") {

        if (v.value1 == null || v.value2 == null) return;
        if (v.uk.value1 == null || v.uk.value2 == null) return;

        v.value1.impossible = this.isImpossibleLimitReached(this.getDelta(v.uk.value1, v.value1.readings),
          this.valueLimits.settings[v.resourceType + "_DAY"]);

        v.value2.impossible = this.isImpossibleLimitReached(this.getDelta(v.uk.value2, v.value2.readings),
          this.valueLimits.settings[v.resourceType + "_NIGHT"])

      } else {

        if (v.value1 == null || v.uk.value1 == null) continue;
        v.value1.impossible = this.isImpossibleLimitReached(this.getDelta(v.uk.value1, v.value1.readings),
          this.valueLimits.settings[v.resourceType]);

        if (v.value2 == null || v.uk.value2 == null) continue;
        v.value2.impossible = this.isImpossibleLimitReached(this.getDelta(v.uk.value2, v.value2.readings),
          this.valueLimits.settings[v.resourceType]);

        if (v.value3 == null || v.uk.value3 == null) continue;
        v.value3.impossible = this.isImpossibleLimitReached(this.getDelta(v.uk.value3, v.value3.readings),
          this.valueLimits.settings[v.resourceType]);
      }
    }
  }

  private showImpossibles(values: Array<any>) {

    for (let v of values) {
      if (v.value1 != null && v.value1.impossible) {
        this.showImpossible();
        return;
      }
      if (v.value2 != null && v.value2.impossible) {
        this.showImpossible();
        return;
      }
      if (v.value3 != null && v.value3.impossible) {
        this.showImpossible();
        return;
      }
    }
  }

  private showErrors(values: Array<any>) {

    for (let v of values) {
      if (v.value1 != null && (!v.value1.impossible && v.value1.error && v.value1.attempts <= 1)) {
        this.showError();
        return;
      }
      if (v.value2 != null && (!v.value2.impossible && v.value2.error && v.value2.attempts <= 1)) {
        this.showError();
        return;
      }
      if (v.value3 != null && (!v.value3.impossible && v.value3.error && v.value3.attempts <= 1)) {
        this.showError();
        return;
      }
    }
  }

  private showError() {
    this.flashMessagesService.show('Показания НЕ приняты! Большой расход! Проверьте ' +
      'показание и попробуйте отправить снова.', {
      cssClass: 'popup-warning flashfade_15 alert-warning',
      timeout: 15000
    });
  }

  private showImpossible() {
    this.flashMessagesService.show('Показания НЕ приняты! Внимание! Очень большой расход. ' +
      'Проверьте показания и попробуйте отправить снова либо свяжитесь с УК.',
      {cssClass: 'popup-message flashfade_15 alert-danger', timeout: 15000});
  }

  private getAttemptsNumber(values) {
    // return values.reduce((a, b) => a.attempts > b.attempts ? a : b);
    return 1;

  }

  private getAmountOfImpossibles(values): number {

    // console.log('GetAmountOfImpossibles: ', values);

    let amountOfImpossibles = values.filter(v => v.activeValuesNumber >= 1 && v.value1 != null &&
      (v.value1.impossible)).length;

    if (amountOfImpossibles > 0) {
      return amountOfImpossibles;
    }

    amountOfImpossibles += values.filter(v => v.activeValuesNumber >= 2 && v.value2 != null &&
      (v.value2.impossible)).length;

    if (amountOfImpossibles > 0) {
      return amountOfImpossibles;
    }

    amountOfImpossibles += values.filter(v => v.activeValuesNumber >= 3 && v.value3 != null &&
      (v.value3.impossible)).length;

    return amountOfImpossibles;
  }

  private getAmountOfNotConfirmedErrors(values: Array<any>): number {
    // console.log('getAmountOfNotConfirmedErrors: ', values);

    let amountOfNonConfirmed = values.filter(v => v.activeValuesNumber >= 1 && v.value1 != null &&
      (v.value1.error && v.value1.attempts < 1)).length;

    if (amountOfNonConfirmed > 0) {
      return amountOfNonConfirmed;
    }

    amountOfNonConfirmed += values.filter(v => v.activeValuesNumber >= 2 && v.value2 != null &&
      (v.value2.error && v.value2.attempts < 1)).length;

    if (amountOfNonConfirmed > 0) {
      return amountOfNonConfirmed;
    }

    amountOfNonConfirmed += values.filter(v => v.activeValuesNumber >= 3 && v.value3 != null &&
      (v.value3.error && v.value3.attempts < 1)).length;

    return amountOfNonConfirmed;
  }

  private incrementAttemptsNumber(values) {

    // console.log("incrementAttemptsNumber", values);

    for (let v of values) {

      if (v.activeValuesNumber < 1) continue;
      if (v.value1 != null && !v.value1.impossible && v.value1.error) {
        v.value1.attempts++;
      }

      if (v.activeValuesNumber < 2) continue;
      if (v.value2 != null && !v.value2.impossible && v.value2.error) {
        v.value2.attempts++;
      }

      if (v.activeValuesNumber < 3) continue;
      if (v.value3 != null && !v.value3.impossible && v.value3.error) {
        v.value3.attempts++;
      }
    }
  }

  private isErrorLimitReached(value, errorValueLimit): boolean {
    if (value == null || value.impossible) return false;
    return value > errorValueLimit.error.positiveLimit ||
      value < errorValueLimit.error.negativeLimit * -1;
  }

  private isImpossibleLimitReached(value, impossibleValueLimit): boolean {
    if (value == null) return false;
    return value > impossibleValueLimit.impossible.positiveLimit ||
      value < impossibleValueLimit.impossible.negativeLimit * -1;
  }

  private checkFormat(values): boolean {
    const isValid = false;

    const meterValueRegex = /^(\d{1,6})?(\.\d+)?$/;
    console.log('Cheking meters: ', values);

    for (let i = 0; i < values.length; i++) {

      if (values[i].value1 != null && values[i].activeValuesNumber >= 1) {
        if (!meterValueRegex.test(values[i].value1.readings)) {
          return false;
        }
      }
      if (values[i].value2 != null && values[i].activeValuesNumber >= 2) {
        if (!meterValueRegex.test(values[i].value2.readings)) {
          return false;
        }
      }
      if (values[i].value3 != null && values[i].activeValuesNumber >= 3) {
        if (!meterValueRegex.test(values[i].value3.readings)) {
          return false;
        }
      }
    }

    return true;
  }

  private isEmpty(meter): boolean {

    if (meter.activeValuesNumber >= 1 && meter.value1 != null && meter.value1.readings == 0) {
      return true;
    }
    if (meter.activeValuesNumber >= 2 && meter.value2 != null && meter.value2.readings == 0) {
      return true;
    }
    if (meter.activeValuesNumber >= 3 && meter.value3 != null && meter.value3.readings == 0) {
      return true;
    }

    return false;
  }

  //</editor-fold>

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/widget/send-values-widget/send-values-widget.component.ts